"use client";

import { Skeleton } from "@/components/ui/skeleton";
import { useMobile } from "@/lib/hooks/use-mobile";
import { cn } from "@/lib/utils";

const skeletonItems = [
  { width: "w-[130px]" },
  { width: "w-[114px]" },
  { width: "w-[176px]" },
  { width: "w-[127px]" },
  { width: "w-[117px]" },
  { width: "w-[127px]" },
  { width: "w-[95px]" },
];

export const DietsListingFiltersSkeleton = ({
  type = "listing",
}: {
  type?: "cateringSingle" | "listing";
}) => {
  const { isMobile, isMobileExtended } = useMobile();

  if (isMobile || (isMobileExtended && type === "cateringSingle")) {
    return (
      <div className="flex w-full flex-col gap-6">
        <div className="flex items-center gap-3">
          <Skeleton className="h-14 w-28 rounded-md" />
          {type === "cateringSingle" && (
            <Skeleton className="h-14 w-28 rounded-md" />
          )}
          <Skeleton className="h-14 w-32 rounded-r-none rounded-l-md" />
        </div>
        {type === "cateringSingle" && (
          <Skeleton className="h-5 w-22 rounded-[6px]" />
        )}
      </div>
    );
  }
  return (
    <div
      className={cn(
        "flex w-76 flex-col gap-2",
        type === "cateringSingle" && "max-md:hidden",
      )}
    >
      {type === "listing" && (
        <div className="rounded-xl border border-input p-5">
          <Skeleton className="h-12 w-full rounded-lg" />
        </div>
      )}
      <div className="flex flex-col rounded-2xl border border-input">
        <div className="flex items-center justify-between px-5 py-4">
          <Skeleton className="h-4.5 w-30" />
          <Skeleton className="size-6 rounded-[4px]" />
        </div>
        <div className="flex flex-col gap-3 border-input border-t p-4">
          <div className="flex flex-wrap gap-3">
            {skeletonItems.map((chip, index) => (
              <Skeleton
                className={cn(
                  "flex h-12 items-center rounded-lg px-3 py-2.5",
                  chip.width,
                )}
                key={index}
              >
                <div className="h-5 w-5 shrink-0 rounded-sm bg-background" />
              </Skeleton>
            ))}
          </div>
          <Skeleton className="h-4.5 w-30 rounded-[6px]" />
        </div>
      </div>

      {Array.from({ length: 3 }).map((_, index) => (
        <div
          className="flex h-14.5 items-center justify-between rounded-2xl border border-input p-4"
          key={index}
        >
          <Skeleton className="h-4.5 w-30 rounded-[6px]" />
          <Skeleton className="h-4 w-4 rounded-[4px]" />
        </div>
      ))}
    </div>
  );
};
